<template>
	<div class="modal-header-wrapper" :class="style()">
		<div class="modal-header" v-if="options.showHeader">
			<div class="modal-header-left-item modal-item">
				<BaseBackButton 
					:title="options.backTitle"
					:click="closeModal"
					:showIcon="options.showBackButtonIcon"
					v-if="options.showBackButton"
					ariaLabel="close modal dialog" />
			</div>
			<div class="modal-header-title modal-item" tabindex="0" role="title" :aria-label="`dialog title: ${options.title}`">
				<component :is="options.component" v-if="options.component"/>
				<span v-html="options.title"></span>
			</div>
			<div class="modal-header-right-item modal-item">
				<BaseIcon
					class="modal-close-button"
					icon="close"
					:isCustom="true"
					type="standard"
					@click="closeModal"
					ariaLabel="close modal dialog"
					v-if="options.showCloseButton" />
			</div>
		</div>
	</div>
</template>

<script>
	import { setTimeout } from 'timers';
	export default {
		props: {
			options: {
				type: Object,
			},
			modalName: {
				type: String,
				default: 'contentModal'
			}
		},
		computed: {
			isPopup() {
				if (this.options.popup) {
					return true;
				}
				return false;
			},
		},
		methods: {
			closeModal() {
				this.$modal.hide(this.modalName);
			},
			style() {
				const popup = this.isPopup;
				return {
					'modal-header--popup': popup,
					'modal-header--full-mobile': !popup,
				};
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;

		padding: 1rem;

		border-bottom: 1px solid $greyOutline;

		.modal-item {
			flex: 1;
		}

		.modal-header-title {
			flex: 2;

			text-align: center;
			font-size: 1.5rem;
			font-weight: bold;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
	.modal-header-right-item {
		display: flex;
		flex-direction: row-reverse;
		.modal-close-button {
			cursor: pointer;
			color: $storeButtonColor;
			z-index: $zTopInteractionLayer;
		}
	}
	@include desktop {
		.modal-header {
			background-color: $checkoutBackgroundColor;
		}
	}

	@include mobile {
		.modal-header-wrapper {
			&.modal-header--full-mobile {
				position: absolute;
				top: 0;
	
				width: 100vw;
				height: 100vh;
	
				pointer-events: none;
				z-index: $zModalTopLayer;
				.modal-header {
					position: absolute;
					top: 0;
		
					width: 100vw;
					max-height: $mobileNavigationHeight;
					background-color: $landingPageBackground;
		
					z-index: $zModalTopLayer;
					pointer-events: all;
					.modal-header-title {
						min-width: 50vw;
						font-size: 1.1rem;
					}
				}
			}
			&.modal-header--popup {
				width: 420px;
				max-width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/global-modal/ContentModalHeader.vue